import React from 'react'
import { useTranslation } from "react-i18next";
import uploadicon from "../../../../assets/images/uploadicon.svg"
import leftarrow from "../../../../assets/images/left-arrow.svg";
import { Footer } from '../../../common/footer/footer';
import fileuploadpopup from "../../../../assets/images/fileuploadpopup.svg";
import datecalender from "../../../../assets/images/datecalender.svg"
import alertCircle from "../../../../assets/images/planpricingtooltip.svg";
import DatePicker3 from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Select, { components } from 'react-select';
import { useHistory } from "react-router-dom";
import { formatInputValue } from '../../../../shared/helper';
import InputMask from 'react-input-mask';
import { NEW_URL } from '../../../../constants/applicationConstants';
import { TagsInput } from "react-tag-input-component";
import swal from "sweetalert";
import styles from './expertRegistration.module.css';
const InstitutionalRegistrationJSX = (props) => {
  const { t } = useTranslation();

 
  const history = useHistory();
  const {
    field,
    formData,
    onInputChangeHandler,
    onTouchHandler,
    formSubmitButtonDisable,
    formError,
    onDateChange,
    handleChange,
    onNextButtonClick,
    getSocialImage,
    onFileChange,
    imageName,
    profileImagePreviewUrl,
    imgURL,
    sameError,
    editMode,
    onMetaTagChange
  } = props;

  const minimumDate = {
    year: 2005,
    month: 1,
    day: 30
  };
  const defaultValue = {
    year: 2005,
    month: 1,
    day: 30
  };
  const personalFieldNames = [
    'firstName',
    'lastName',
    'expertEmail',
    'altEmail',
    'primaryContact',
    'secondaryContact',
    'dateOfBirth',
    'gender'
  ];
  const socialFieldNames = [
    'facebook',
    'insta',
    'twitter',
    'linkedin'
  ];
  const billingFieldNames = [
     'billing_postalCode',
     'billing_province',
     'billing_city',
     'billing_country',
     'billing_street',
     'contactEmail'
  ];
  const certificateFieldNames = [
    'certification',
    'awards'
 ];
 const personalDetailsField = [];
 const socialDetailsField = [];
 const billingDetailsField = [];
 const certificateDetailsField = [];

 field?.forEach((item) => {
  if (item.fieldType === "text" && item.contentHeading === "REGISTRATION.SOCIALMEDIA") {
    socialDetailsField.push(item);
    return;
  }

  if (item.fieldType === "text" && item.contentHeading === "REGISTRATION.BILLINGADDRESS") {
    billingDetailsField.push(item);
    return;
  }

  if (item.fieldType === "text" && item.contentHeading === "REGISTRATION.Certifications_heading") {
    certificateDetailsField.push(item);
    return;
  }

  // Handle multiple fields
  if (item.fieldType === "multiple") {
    const isPersonal = item.fields.some(f => personalFieldNames.includes(f.name));
    const isSocial = item.fields.some(f => socialFieldNames.includes(f.name));
    const isBilling = item.fields.some(f => billingFieldNames.includes(f.name));
    const isCertificate = item.fields.some(f => certificateFieldNames.includes(f.name));

    if (isPersonal) {
      personalDetailsField.push(item);
    } else if (isSocial) {
      socialDetailsField.push(item);    
    } else if (isBilling) {
      billingDetailsField.push(item);    
    } else if (isCertificate) {
      certificateDetailsField.push(item);
    }
  }
  // Handle social fields
  else if (item.fieldType === "social") {    
    
      socialDetailsField.push(item);    
    
  }
  // Single input/select fields
  else if (personalFieldNames.includes(item.name)) {
    personalDetailsField.push(item);
  } else if (socialFieldNames.includes(item.name)) {
    socialDetailsField.push(item);  
  } else if (billingFieldNames.includes(item.name)) {
    billingDetailsField.push(item);
  } else if (certificateFieldNames.includes(item.name)) {
    certificateDetailsField.push(item);
  }
});

const renderField = (item, i) => (
  <React.Fragment key={i}>
  {item.fieldType === "metaTags" &&
    <div><label>{item.placeholder}{item.showTooltip && <span className="plantooltip custooltip" title="" > <img src={alertCircle} className="tooltipim" alt={' '}  /><div className="tooltipcontent">{item.tooltipTitle}</div></span>}</label>
      <div className="mb-4 input-container form-group specialtag">
      
      <div className="normal" id={`tagI${i}`} 
                                    onFocus={()=>{
                                        let elem = document.getElementById("tagI"+i); 
                                        elem.classList.add("my-classfocus"); 
                                    }}          
                                    onBlur={()=>{
                                        let elem = document.getElementById("tagI"+i); 
                                        elem.classList.remove("my-classfocus"); 
                                    }}  
                                    
                                    >

<TagsInput
          value={formData[item.name]}
          onKeyUp={(e) => {
            
          }}
          onBlur={(e) => {
            if (e.target.value) {
              onMetaTagChange([...formData[item.name], e.target.value],item);
              e.target.value = "";
            }
          }}
          onChange={(e) => onMetaTagChange(e, item)}
          separators={['Enter',',','Done','Next']}
          label="xxxxxxxxx"
          name={item.name}
          maxLength={item.maxLength}
          placeHolder=" "
          classname={{tag: 'tag-clsxxxx', input: 'input form-control'}} 
          
        />
        {/* <TagsInput
  value={formData[item.name]}
  onChange={(e) => onMetaTagChange(e, item)}
  separators={['Enter',',']}
  inputProps={{ 
    enterKeyHint: "done",   // <--- this helps Android keyboard
    inputMode: "text" 
  }}
  label=" "
  name={item.name}
  maxLength={item.maxLength}
  placeHolder=" "
  classname={{ tag: 'tag-cls', input: 'input-caption' }}
/> */}
        {/* <TagsInput
  value={formData[item.name]}
  onKeyDown={(e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      if (e.target.value) {
        onMetaTagChange([...formData[item.name], e.target.value]);
        e.target.value = "";
      }
    }
  }}
  onBlur={(e) => {
    if (e.target.value) {
      onMetaTagChange([...formData[item.name], e.target.value]);
      e.target.value = "";
    }
  }}
  inputProps={{ 
    enterKeyHint: "done",   // <--- this helps Android keyboard
    inputMode: "text" 
  }}
  label=" "
  name="metaTags"
  placeHolder=" "
  classname={{ tag: 'tag-cls', input: 'input-caption' }}
/> */}
        
         </div>
                                  
      </div>
    </div>
  }

  {item.fieldType === "input" &&
    <div>

      <div className="mb-4 input-container form-group">
      <label>{t(`${item.placeholder}`)}</label>
        {item.name === 'postalCode'  || item.name === 'billing_postalCode' ?
          <InputMask 
          mask={getMuskPattern(item.name)} 
          value={formData[item.name]} 
          name={item.name} 
          onChange={onInputChangeHandler} 
          onBlur={onTouchHandler}
          >
            {(inputProps) => 
            <input {...inputProps} 
            className="input form-control" 
            placeholder=" " 
            disableUnderline 
            />}
          </InputMask> :
          <input
            onChange={onInputChangeHandler}
            onBlur={onTouchHandler}
            required
            type={item.type}
            className={
              item.isRequired && formError[item.name]
                ? "input form-control  is-invalid"
                : "input form-control"
            }
            id={item.name}
            name={item.name}
            placeholder={" "}
            maxLength={item.maxLength}
            value={formData[item.name]}
          />}
       
        
        <span className="text-danger">
          {item.isRequired &&
            formError[item.name] &&
            (formError[item.name] === "req"
              ? t(item.error)
              : t(item.type_error))}
        </span>
      </div>
    </div>}

  {item.fieldType === "select" &&
    <div className={`mb-4 input-container selectboxmain form-group ${formData[item.name] && `selecttransition`}`}>
       <label>{t(`${item.placeholder}`)} </label> <>
        <Select className={`selectbox`}
          closeMenuOnSelect={true}
          classNamePrefix="custom-select"
          options={item?.options}
          placeholder={" "}
          onChange={(e) => handleChange(e, item)}
          components={{
            Input: (props) => {
             
              return <>
          
               <components.Input {...props} className={"mb-4 input-container form-group"} >
                  {props.children}
                </components.Input>
              </>
            },
          }}

          value={item?.options.filter(ite => ite.value === formData[item.name])}
        />

      </>
    </div>
  }
  {
    item.fieldType === "multiple" &&
    <div className={`disgrid grid-${item.fields.length}`}>
      {item.fields.map((items) => {
        return <>
          {
            items.fieldType === "input" &&
            <div>

              <div className="mb-4 input-container form-group">
              <label>{t(`${items.placeholder}`)} </label>
                {
                  items.name === 'phone' || items.name === 'secondaryContact' || items.name === 'primaryContact' || items.name === 'postalCode'  || items.name === 'billing_postalCode' ?
                    <InputMask mask={getMuskPattern(items.name)} value={formData[items.name]} name={items.name} onChange={onInputChangeHandler} onBlur={onTouchHandler}>
                      {(inputProps) => <input {...inputProps} type={items.type} className="input form-control" placeholder=" " disableUnderline />}
                    </InputMask> :
                    <input
                      onChange={onInputChangeHandler}
                      onBlur={onTouchHandler}
                      required
                      type={items.type}
                      className={
                        items.isRequired && formError[items.name]
                          ? "input form-control  is-invalid"
                          : "input form-control"
                      }
                      id={items.name}
                      name={items.name}
                      placeholder={" "}
                      maxLength={items.maxLength}
                      value={formData[items.name]}
                    />}
               {items.showIcon && (
                  <img
                    src={items.icon}
                    alt={`${items.name}-icon`}
                  className={`${styles.imageiconform}`}
                  />
                )}
               
                <span className="text-danger">
                  {items.isRequired &&
                    formError[items.name] &&
                    (formError[items.name] === "req"
                      ? t(items.error)
                      : t(items.type_error))}
                </span>
                { items.name === 'expertEmail' || items.name === 'altEmail'? 
              sameError ? <span className="text-danger samemailerr">Login email &amp; alternative email can’t be same</span> : null: null  
              }
              </div>
            </div>
          }{
            items.fieldType === "select" &&
            <div className={`mb-4 input-container selectboxmain form-group ${formData[items.name] && `selecttransition`}`}>
              <>
              <label> {t(`${items.placeholder}`)} </label>
                <Select className={`selectbox`}
                  classNamePrefix="custom-select"
                  closeMenuOnSelect={true}
                  placeholder={" "}
                  options={items?.options}
                  onChange={(e) => handleChange(e, items)}
                  value={items?.options.filter(ite => ite.value === formData[items.name])}

                  components={{
                    Input: (props) => {
                

                      return <>
                      

                        <components.Input {...props} className={"input-container form-group"} >
                          {props.children}
                        </components.Input>
                      </>
                    },
                  }}
                />
                {/* <div className="placeholder">{t(`${items.placeholder}`)} {item.showTooltip && <span className="plantooltip custooltip" title="" > <img src={alertCircle} className="tooltipim"  alt={' '} /><div className="tooltipcontent">{item.tooltipTitle}</div></span>}</div> */}
              </>
            </div>
          }
          {items.fieldType === "date" &&
            <>
               
              <DatePicker3 className="form-control" name="startDate"
                onChange={(date) => { onDateChange(date) }}
                inputPlaceholder="dd/mm/yyyy"
                shouldHighlightWeekends
                value={defaultValue}

                // maximumDate={{
                //   year: new Date().getFullYear(),
                //   month: new Date().getMonth() + 1,
                //   day: new Date().getDate()
                // }}
                maximumDate={minimumDate}
                wrapperClassName="input-container form-group"
                renderInput={({ ref }) => (
                  <>
                  <label>{t(`${items.placeholder}`)}</label>
                    <input
                      ref={ref}
                      placeholder=" "
                      type="text"
                      required
                      className="input form-control"
                      value={formatInputValue(formData.dateOfBirth)}
                    />
                   <img src={datecalender} alt={' '} className={`${styles.imageiconform}`} />
                  </>
                )}
                formatInputText={() => formatInputValue(formData.dateOfBirth)}
              />
            </>
          }
        </>
      })}
    </div>
  
  }
  {
    item.fieldType === "text" &&
    <div className="primarycontact mb-4">
      <h4 className="h4_style ">{t(`${item.contentHeading}`)}</h4>
      <h5 className="h5_style ">{t(`${item.SUBHEADING1}`)}</h5>
    
    </div>
  }
  {item.fieldType === "social" &&
    <div className="disgrid grid-2">
      {
        item.types.map(items =>
          <div className="input-container form-group social-control">
              
            <input
              type="text"
              required=""
              name={items.name}
              className={
                items.isRequired && formError[items.name]
                  ? "input form-control  is-invalid"
                  : "input form-control"
              }
              placeholder={t("REGISTRATION.LINK")}
              onChange={onInputChangeHandler}
              value={formData[items.name]}
              maxLength={items.maxLength}
            />
      
           
            <img src={getSocialImage(items)} className="formscicon"  alt={' '}  />
            {items.showIcon && (
                  <img
                    src={items.icon}
                    alt={`${items.name}-icon`}
                  className={`${styles.imageiconform} social-controlicon`}
                  />
                )}
            <span className="text-danger">
              {items.isRequired &&
                formError[items.name] &&
                (formError[items.name] === "req"
                  ? t(items.error)
                  : t(items.type_error))}
            </span>
          </div>
        )
      }
    </div>
  }
  {item.fieldType === "multiSelect" &&
    <>

      <Select className="mb-4 form-container form-group multiselect"
      classNamePrefix="multicustomselect"
        closeMenuOnSelect={false}
        isMulti
        options={item?.options}
        onChange={(e) => handleChange(e, item)}
        value={formData['category']}
        components={{
          Input: (props) => {
            const { value } = props

            return <>
              <label className={`multiplaceholer ${(formData['category']?.length > 0 || value !== '') ? 'active' : ''}`}>{t(`${item.placeholder}`)}
                {item.showTooltip && <span className="plantooltip custooltip" title="" > {<img src={alertCircle} className="tooltipim"  alt={' '} />}<div className="tooltipcontent">{item.tooltipTitle}</div></span>}
              </label>

              <components.Input {...props} className={"mb-4 input-container form-group"} >
                {props.children}
              </components.Input>
            </>
          },
          Option: (props) => {
            const { isSelected } = props

            return (
              <div>
                <components.Option {...props}>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => null}
                  />
                  {props.children}
                </components.Option>
              </div>
            );
          }
        }}

      />
    </>
  }
</React.Fragment>

);

 
  const instituteExpert = localStorage.getItem('instituteExpert');
  const backInstitute = () => {
 
    swal({
      title: "Are you sure you want to Back ?",
      icon: "warning",
      buttons: [
        'Keep Logged in!',
        'Yes, Back!'
      ],
      dangerMode: true,
    }).then(function (isConfirm) {
      if (isConfirm) {
        let oldToken = localStorage.getItem("instituteExpertToken")
        localStorage.setItem("token", oldToken);
        history.push("/dashBoard");
        localStorage.removeItem("expertId");
        localStorage.removeItem("expertData");
        localStorage.removeItem("comingFromInstitute");
        localStorage.removeItem("comingFrom");

        localStorage.removeItem("description");

        localStorage.setItem('flowName', 'institute')
        localStorage.setItem('flowType', 'institute')
        localStorage.removeItem("instituteExpert");
        localStorage.removeItem("adInsExpert");

        localStorage.removeItem("instituteExpertToken");

        // window.location.reload()
        // localStorage.setItem("token", JSON.stringify(adminToken));
        // localStorage.removeItem("adminOldToken")
        // localStorage.removeItem("loginData")
        // localStorage.removeItem("expertId")
        // localStorage.removeItem("instituteId")
        // localStorage.removeItem("slugSet")
        window.location.reload()
      } else {
        //   swal("Cancelled", "Your imaginary file is safe :)", "error");
      }
    })
  }

  const getMuskPattern = (name) =>
    (name === 'phone' || name === 'secondaryContact' || name === 'primaryContact') ? '(999) 999 9999' : 'a9a 9a9'


    const removeId = ()=>{
      if(instituteExpert){
        backInstitute()
      }else{
        const adminToken = localStorage.getItem('adminOldToken');
        const adminOldId = localStorage.getItem('adminOldId');
  
        localStorage.removeItem("VerifyExpertID")
        localStorage.setItem("token", JSON.stringify(adminToken));
        localStorage.setItem("masterID", adminOldId);
        localStorage.removeItem("adminOldToken");
        localStorage.removeItem("adminOldId")
        history.goBack()
      }
     
    }

   
  

  return (
    <section className="mainloginscreen expertregistrationnew">
      <div className="container">
      <div className={`${styles.mainloginscreeninner}`}>
            <div className={`${styles.leftsightbackdetails}`}>
              <div className="detailsleft plaindetailsleft  d-flex align-items-center justify-content-center">
                <div className="back_btn" onClick={() =>removeId()}>
                  <img src={leftarrow} alt={' '} />
                </div>
                <h1>{t("REGISTRATION.EXPERTTITLE")}</h1>
              </div>
              <div className="numberingwizerd">
                  <ul className="d-flex align-items-center justify-content-center ">
                    <li className="active">1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                  
                  </ul>
                </div>
            </div>
           
          </div>
       
       
          <div className={`${styles.formsection}`}>
            <div className={`${styles.institutelogintext}`}>
            
              <h2 className="h2_style text-center">{t("REGISTRATION.LETUSKNOW")}</h2>
              <h6 className="h6_style text-center">{t("REGISTRATION.ENTERINFO")}</h6>
              <p className="text-center smalltext">{t("REGISTRATION.MANDATORY")} </p>
              {/* <h4 className="h4_style text-center">{t("REGISTRATION.INSTITUTIONALDETAILS")}</h4>
              <h5 className="h5_style text-center">{t("REGISTRATION.DESCRIPTION")}</h5> */}
           {/* uploadsec */}
           <div className={`${styles.maindiv} mt-4 d-flex align-items-center`}>
         
              <div className="detailsleft">
          
                <a href="#logochangeModal"><div className={`${styles.uploadlogo}`}>
                  {
                    profileImagePreviewUrl ?
                      <img
                        src={profileImagePreviewUrl}
                        height="170px"
                        width="250px"
                        alt="edit profile"
                      /> :
                      editMode ?
                        <img
                          src={`${NEW_URL}/${imgURL}`}
                          height="170px"
                          width="250px"
                          alt="edit profile"
                        />
                        : t("REGISTRATION.LOGO")
                  }
                </div></a>
                <div id="logochangeModal" className="modal-window">

                  <div>
                    <button  title="Close" className="modal-close">{t("REGISTRATION.CLOSE")}</button>
                    <div className="modal-header"><h2 className="h2_style">{t("REGISTRATION.LOGOCHANGE")}</h2></div>
                    <div className="modal-body mb-4">
                      <div className="modal-body-inner">
                        <div className="button_outerlogo">
                          <div className="btn_uploadlogo"><input type="file" id="upload_filelogo" name="" onChange={onFileChange} />
                            <label for="upload_filelogo">

                              {
                                profileImagePreviewUrl ?
                                  <img
                                    src={profileImagePreviewUrl}
                                    height="170px"
                                    width="250px"
                                    alt="edit profile"
                                  /> :
                                  editMode ?
                                    <img
                                      src={`${NEW_URL}/${imgURL}`}
                                      height="170px"
                                      width="250px"
                                      alt="edit profile"
                                    />
                                    : <img src={fileuploadpopup} alt={' '}  />
                              }
                            </label>
                          </div>
                        </div>
                        {imageName && <h6 className='text-center'>{imageName}</h6>}
                        {!(editMode || profileImagePreviewUrl) && <><h5 className="text-center h5_style">{t("REGISTRATION.UPLOADLOGOIMAGE")}</h5>
                          <p className="text-center">{t("REGISTRATION.ADDICON")}</p></>}
                      </div>
                    </div>
                    {(profileImagePreviewUrl || editMode) && <div className="modal-footer">
                    <div className={`${styles.uploadbutton} button_outer`}>
                        <div className="btn_upload">
                          <input type="file" id="upload_file" name="" onChange={onFileChange} />
                          <label for="upload_file">{"Change Icon"}</label>
                        </div>
                      </div>
                    </div>}

                  </div>
                </div>

                <main className={`${styles.main_full_tp}`}>

                  <div className="uploadproduct">
                    <div className={`${styles.uploadbuttonouter} button_outer`}>
                      <div className={`${styles.uploadbutton} btn_upload`}>
                        <input type="file" id="upload_file" name=""
                          accept="image/png, image/gif, image/jpeg"
                          onChange={onFileChange}
                        />
                        <label for={`${styles.buttonuploadlevel}`}>{t("REGISTRATION.FILEUPLOADTEXT")} <img src={uploadicon} alt={`icon`}/></label>
                      </div>
                    </div>
                  </div>
                  {/* <div className="btn_upload">
                        <input type="file" id="upload_file" name="" onChange={onFileChange} />
                        <label for="upload_file">{t("REGISTRATION.FILEUPLOADTEXT")}</label>
                      </div> */}
                  <div className="error_msg"> {t("REGISTRATION.IMAGEMSGNEW")} </div>
                  <div className="error_msg"> {t("REGISTRATION.IMAGEMSGTWO")}</div>
                </main>
                

              </div>
            </div>
            {/* personal details section */}
            <div className={`${styles.maindiv}`}>
             {personalDetailsField.map((item, i) => renderField(item, i))}
            </div>
            {/* social details section */}
            <div className={`${styles.maindiv} socialdiv`}>
             {socialDetailsField.map((item, i) => renderField(item, i))}
            </div>
            {/* billing details section */}
            <div className={`${styles.maindiv}`}>
             {billingDetailsField.map((item, i) => renderField(item, i))}
            </div>
            {/* certificate details section */}
            <div className={`${styles.maindiv} crtificate`}>
             {certificateDetailsField.map((item, i) => renderField(item, i))}
            </div>
      
              {/* {field?.map((item, i) => (
               ))} */}

            <div className="d-flex justify-content-center"> <button className={formSubmitButtonDisable || sameError ? ' mt-4 mainbutton' : 'mt-4 mainbutton'} disabled={formSubmitButtonDisable || sameError} onClick={() => onNextButtonClick()}>{t("REGISTRATION.NEXT")}</button></div> 
              {/* <button className='mt-4 ctaonebutton'onClick={() => testClick()}>{t("REGISTRATION.NEXT")}</button> */}

            </div>
          </div>
       
      </div>
      <Footer/>
    </section>
  );
};

export default InstitutionalRegistrationJSX;
